import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/social-listening/settings')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/social-listening' })
  },
})
